export default "__VITE_ASSET__D1dvEte$__"